import { FormTypes } from '@oneblink/types'
import { conditionalLogicService } from '@oneblink/sdk-core'

export default function makeIsShowing(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  const formElementsConditionallyShown =
    conditionalLogicService.generateFormElementsConditionallyShown({
      submission,
      formElements: definition.elements,
    })

  return (submissionFieldName: string) =>
    formElementsConditionallyShown[submissionFieldName]?.isHidden === false ??
    false
}

export function makeIsOptionShowing({
  submission,
  definition,
}: {
  submission: Record<string, unknown>
  definition: FormTypes.Form
}) {
  return ({
    option,
    element,
  }: {
    option: FormTypes.ChoiceElementOption
    element: FormTypes.FormElementWithOptions
  }) =>
    option.attributes?.every((predicate) =>
      conditionalLogicService.evaluateConditionalPredicates({
        isConditional: element.conditionallyShow,
        requiresAllConditionalPredicates:
          element.requiresAllConditionallyShowPredicates || false,
        conditionalPredicates: [
          {
            elementId: predicate.elementId,
            type: 'OPTIONS',
            optionIds: predicate.optionIds,
          },
        ],
        submission,
        formElements: definition.elements,
      }),
    )
}
